import { z, ZodType } from "zod";

const agreementValidator: ZodType = z.custom<string>((value): boolean => {
  return value === true || value === "1";
}, "Zgoda wymagana");

type agreementValidator = z.infer<typeof agreementValidator>;

export default agreementValidator;
